var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Downloaded Files",
        visible: _vm.showDownloadVis,
        "before-close": _vm.handleClose,
        width: "70%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.showDownloadVis = $event
        },
      },
    },
    [
      _c(
        "el-table",
        { attrs: { data: _vm.gridData, "max-height": "250", stripe: "" } },
        [
          _c("el-table-column", {
            attrs: { prop: "fileName", label: "File Name", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("i", {
                      staticClass: "el-icon-download download-icon",
                      on: {
                        click: function ($event) {
                          return _vm.downloadClick(scope.row)
                        },
                      },
                    }),
                    _vm._v(" " + _vm._s(scope.row.fileName) + "\n      "),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "fileSize", label: "File Size" },
          }),
          _c("el-table-column", {
            attrs: { prop: "kccTitle", label: "KCC Title" },
          }),
          _c("el-table-column", {
            attrs: { prop: "uploadBy", label: "Uploaded by" },
          }),
          _c("el-table-column", {
            attrs: { prop: "uploadTime", label: "Uploaded time" },
          }),
          _c("el-table-column", {
            attrs: { prop: "downloadBy", label: "Downloaded by" },
          }),
          _c("el-table-column", {
            attrs: { prop: "downloadTime", label: "Downloaded time" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }